import React from 'react';
import { styled } from '@compiled/react';

import { PageCommentEditor, type CommentSaveHandler } from '@confluence/comment-simple';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FooterWrapperContainer = styled.div({
	minHeight: 40,

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'div.ak-editor-content-area': {
		overflowY: 'scroll',
		height: 95,
	},
});

export const CommentsPanelFooter = () => {
	const handleCommentsPanelSave: CommentSaveHandler = (_adf) => {
		return Promise.resolve('implement me!');
	};

	const handleCancel = ({ isEditorAborted }: any) => {
		if (isEditorAborted) {
			// Do aborted stuff
		}

		// Do other cancel stuff
	};

	const handleOnEditorLoaded = () => {
		// Do editor loading things
	};

	const handleAfterActivate = () => {
		// Do after activate things
	};

	return (
		<FooterWrapperContainer>
			<PageCommentEditor
				mode="create"
				saveHandler={handleCommentsPanelSave}
				cancelHandler={handleCancel}
				onEditorLoaded={handleOnEditorLoaded}
				afterActivate={handleAfterActivate}
				expandEditor={false}
			/>
		</FooterWrapperContainer>
	);
};
